// process.env.* is replaced by rollup at build time
export const config = {
  // @ts-ignore
  queueName: /** @type {string} */ (process.env.QUEUE_NAME),
  // @ts-ignore
  objectName: /** @type {string} */ (process.env.OBJECT_NAME),
};
